module.exports = __webpack_public_path__ + "static/media/zoom_no_extension.af4af73d.png";